(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket-payment', {
            parent: 'entity',
            url: '/ticket-payment?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.ticketPayment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-payment/ticket-payments.html',
                    controller: 'TicketPaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                field: null,
                status: 'UNKNOWN',
                userPhone: null,
                fromDate: null,
                toDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        field: $stateParams.field,
                        status: $stateParams.status,
                        userPhone: $stateParams.userPhone,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketPayment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticket-payment-detail', {
            parent: 'ticket-payment',
            url: '/ticket-payment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.ticketPayment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-payment/ticket-payment-detail.html',
                    controller: 'TicketPaymentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketPayment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TicketPayment', function($stateParams, TicketPayment) {
                    return TicketPayment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket-payment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticket-payment-detail.edit', {
            parent: 'ticket-payment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-payment/ticket-payment-dialog.html',
                    controller: 'TicketPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketPayment', function(TicketPayment) {
                            return TicketPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-payment.new', {
            parent: 'ticket-payment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-payment/ticket-payment-dialog.html',
                    controller: 'TicketPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ticketId: null,
                                transactionId: null,
                                fromCity: null,
                                toCity: null,
                                departureDate: null,
                                returnDate: null,
                                status: null,
                                amount: null,
                                currency: null,
                                tripType: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticket-payment', null, { reload: 'ticket-payment' });
                }, function() {
                    $state.go('ticket-payment');
                });
            }]
        })
        .state('ticket-payment.edit', {
            parent: 'ticket-payment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-payment/ticket-payment-dialog.html',
                    controller: 'TicketPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketPayment', function(TicketPayment) {
                            return TicketPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-payment', null, { reload: 'ticket-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-payment.delete', {
            parent: 'ticket-payment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-payment/ticket-payment-delete-dialog.html',
                    controller: 'TicketPaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TicketPayment', function(TicketPayment) {
                            return TicketPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-payment', null, { reload: 'ticket-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-order', {
                parent: 'entity',
                url: '/ticket-orders?page&sort&field&status&fromDate&toDate',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/ticket-payment/ticket-order.html',
                        controller: 'TicketOrderController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'orderId,desc',
                        squash: true
                    },
                    field: {
                        value: null,
                        squash: true
                    },
                    status: {
                        value: null,
                        squash: true
                    },
                    fromDate: {
                        value: null,
                        squash: true
                    },
                    toDate: {
                        value: null,
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: [
                        '$stateParams',
                        function ($stateParams) {
                            return {
                                page: $stateParams.page,
                                sort: $stateParams.sort,
                                field: $stateParams.field,
                                status: $stateParams.status,
                                fromDate: $stateParams.fromDate,
                                toDate: $stateParams.toDate
                            };
                        }
                    ],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('ticketPayment');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
